<template>
  <div :style="{height: canvas_h + 'px'}" class>
    <div id="users-list">
      <b-button @click="Collapsed" variant="info" size="sm">Участники</b-button>
      <div id="collapse-1" class="mt-1 overflow-hidden">
        <div
          class="pl-2 user border rounded bg-info text-white"
          v-for="u in users.filter(u => u.online)"
          :key="u.id"
        >{{u.name}} - {{u.scores}}</div>
      </div>
    </div>
    <div :style="{height: chat_h + 'px'}" id="chat">
      <div v-for="{msg, id} in messages" :key="msg.id">
        <b>{{GetNameById(id)}}:</b>
        {{msg}}
      </div>
    </div>
    <div id="chat-send-form" class="d-flex mt-auto">
      <b-input type="text" autocomplete="off" class="col-10" v-model="text_msg" />
      <b-button @click="NewMsg" type="submit" size="sm" variant="info" class="col-2 p-0">
        <b-icon icon="arrow-right" font-scale="2"></b-icon>
      </b-button>
    </div>
  </div>
</template>

<script>
import Dynamics from "dynamics.js";
export default {
  props: {
    canvas_h: { type: Number, default: 100 },
    // userd = { id: "user_id", name: "name_text", avatar: 0, scores: 500 }
    users: { type: Array, default: () => [] },
    // messages = { id: "user_id", msg: "message_text" }
    messages: { type: Array, default: () => [] }
  },
  data() {
    return {
      users_c: false,
      chat_h: 0,
      text_msg: ""
    };
  },
  watch: {
    canvas_h() {
      this.ResizeChat();
    },
    users() {
      this.UpdateHeightListUser();
    }
  },
  methods: {
    NewMsg() {
      this.$emit("new_msg", this.text_msg);
      this.text_msg = "";
    },
    ResizeChat() {
      let a = document.querySelector("#users-list").clientHeight;
      let b = document.querySelector("#chat-send-form").clientHeight;
      this.chat_h = this.canvas_h - (a + b + 5);
    },
    GetNameById(id) {
      let u = this.users.find(u => u.id == id);
      return u ? u.name : "Неизвестный";
    },
    // Cворачивание
    Collapsed() {
      let el = document.querySelector("#collapse-1");
      let h = this.users_c ? 0 : this.users.filter(u => u.online).length * 26;

      Dynamics.animate(
        el,
        { height: h },
        {
          type: Dynamics.gravity,
          duration: 300,
          friction: 500,
          change: (el, progress) => {
            this.ResizeChat();
          }
        }
      );
      this.users_c = !this.users_c;
    },

    UpdateHeightListUser() {
      if (this.users_c) {
        let el = document.querySelector("#collapse-1");
        let h = this.users.filter(u => u.online).length * 26;

        Dynamics.animate(
          el,
          { height: h },
          {
            type: Dynamics.gravity,
            duration: 300,
            friction: 500,
            change: (el, progress) => {
              this.ResizeChat();
            }
          }
        );
      }
    }
  }
};
</script>

<style scoped>
#collapse-1 {
  height: 0;
}
#chat {
  overflow-y: auto;
  overflow-x: hidden;
}
</style>